import React, { useEffect } from 'react'
import { HighlightsSectionProps } from './HighlightsSection.types'
import styles from './HighlightsSection.module.scss'
// import cl from 'classnames'
import {
  EntityInfoNameLine,
  H2,
  HorizontalLine,
  Numbers,
  SectionContainer,
  TabsLine,
  Text2
} from 'components/shared'
import { CirclePieSegment } from '../CirclePieSegment'
import moment from 'moment'
import { observer } from 'mobx-react-lite'
import { inject } from 'mobx-react'
import { STATISTICS_PAGE_STORE, statsColorPallette } from 'store'
import { formatPrice, getMainImageSrcForObj } from 'utilities'
import { IconStatistics } from 'assets'

const HighlightsSectionComponent = (props: HighlightsSectionProps) => {
  const {
    className,
    style,
    skipEffectOnInit,
    labelProps,
    [STATISTICS_PAGE_STORE]: {
      getHighlightStats,
      storeViewTabData,
      setSelectedHighlightTab,
      shopToDisplay,
      getHighlightTabs
    }
  } = props

  useEffect(() => {
    if (skipEffectOnInit) return
    getHighlightStats()
  }, [skipEffectOnInit, getHighlightStats])

  return (
    <SectionContainer className={className} style={style}>
      {shopToDisplay && (
        <>
          <EntityInfoNameLine
            entityName={shopToDisplay.name}
            imageProps={{
              src: getMainImageSrcForObj(shopToDisplay)
            }}
            ratingProps={{
              rating: shopToDisplay.rating,
              reviewsCnt: shopToDisplay.reviewsCnt
            }}
          />
          <HorizontalLine />
        </>
      )}

      <H2
        bold={labelProps?.labelBold}
        style={{ marginTop: 20 }}
      >
        {labelProps?.showIcon && (
          <IconStatistics
            style={{
              fill: styles.primary,
              marginRight: 10
            }}
          />
        )}
        {labelProps?.label || 'Highlights*'}
      </H2>
      <TabsLine
        style={{ marginTop: 10, position: 'relative' }}
        tabs={getHighlightTabs()}
        onSelectedTabChange={setSelectedHighlightTab}
      >
        <Numbers
          style={{
            position: 'absolute',
            right: 0,
            bottom: 15
          }}
        >
          {storeViewTabData.total 
          ? storeViewTabData.isTotalPrice
            ? formatPrice(storeViewTabData.total)
            : Math.round(storeViewTabData.total)
            : ''
          }
          {storeViewTabData.afterTotalLabel && (
            <span className={styles.afterTotalLabel}>
              {storeViewTabData.afterTotalLabel}
            </span>
          )}
        </Numbers>
      </TabsLine>

      <div className={styles.circlesContainer}>
        {storeViewTabData.pieSegments.map((segment, index) => {
          return (
            <CirclePieSegment
              key={segment.label + segment.num}
              {...segment}
              circleBackgroundColor={statsColorPallette[index].background}
              circleFillColor={statsColorPallette[index].fill}
              // delay={index}
            />
          )
        })}
      </div>

      <HorizontalLine />
      <Text2
        style={{
          marginTop: 15,
          color: styles.secondaryContent
        }}
      >
        *Statistics for {moment().subtract(1, 'day').format('DD/MM/YY')} (yesterday) compared to {moment().format('DD/MM/YY')}.
      </Text2>
    </SectionContainer>
  )
}

const HighlightsSection = inject(
  'STATISTICS_PAGE_STORE'
)(observer(HighlightsSectionComponent))
export { HighlightsSection }
